import { createSlice } from "@reduxjs/toolkit";
import { ReducerRegistry } from "@neumetric/blueprint-lib/store";

const DecisionList = [
  { id: "pending", label: "Pending" },
  { id: "acceptable", label: "Acceptable", dotIconName: "APPROVED" },
  { id: "treat", label: "Treat", dotIconName: "LOW" },
  { id: "terminate", label: "Terminate", dotIconName: "MEDIUM" },
  { id: "transfer", label: "Transfer", dotIconName: "MEDIUM" },
  { id: "tolerate", label: "Tolerate", dotIconName: "URGENT" },
  { id: "redundant", label: "Redundant" },
  { id: "inapplicable", label: "Inapplicable" },
];
const SeverityList = [
  { id: "Critical", label: "Critical" },
  { id: "High", label: "High" },
  { id: "Medium", label: "Medium" },
  { id: "Low", label: "Low" },
  { id: "Minimal", label: "Minimal" },
  { id: "None", label: "None" },
];

const StatusList = [
  { id: "pending", label: "Pending" },
  { id: "started", label: "Started" },
  { id: "accepted", label: "Accepted", dotIconName: "APPROVED", isCompleted: true },
  { id: "partial", label: "Partial", dotIconName: "PARTIAL" },
  { id: "treated", label: "Treated", dotIconName: "APPROVED", isCompleted: true },
  { id: "terminated", label: "Terminated", dotIconName: "APPROVED", isCompleted: true },
  { id: "transferred", label: "Transferred", dotIconName: "APPROVED", isCompleted: true },
  { id: "tolerated", label: "Tolerated", dotIconName: "MEDIUM", isCompleted: true },
  { id: "completed", label: "Completed", dotIconName: "APPROVED", isCompleted: true },
  { id: "closed", label: "Closed", dotIconName: "APPROVED", isCompleted: true },
  { id: "redundant", label: "Redundant" },
  { id: "inapplicable", label: "Inapplicable" },
];

const CategoryList = [
  { id: "Human Resources Security", label: "Human Resources Security" },
  {
    id: "Physical & Environmental Security",
    label: "Physical & Environmental Security",
  },
  {
    id: "Communications & Operations Management",
    label: "Communications & Operations Management",
  },
  { id: "Access Control", label: "Access Control" },
  {
    id: "Systems Acquisition, Development & Maintenance",
    label: "Systems Acquisition, Development & Maintenance",
  },
];
const RatingsTypes = [
  { id: "Catastrophic", label: "Catastrophic", dotIconName: "EMERGENCY" },
  { id: "Major", label: "Major", dotIconName: "URGENT" },
  { id: "Moderate", label: "Moderate", dotIconName: "HIGH" },
  { id: "Minor", label: "Minor", dotIconName: "MEDIUM" },
  { id: "Trivial", label: "Trivial", dotIconName: "LOW" },
  { id: "None", label: "None", dotIconName: "LOW" },
];
const initialState = {
  DecisionList,
  SeverityList,
  StatusList,
  CategoryList,
  RatingsTypes,
  risks: null,
  threatsList: [],
  vulnerabilitiesList: [],
  assetsList: [],
  assetTypesList: [],
  referencesList: [],
  ratingsList: [],
  sourcesList: [],
  deptResponders: null,
  dashboardData: [],
  currentRisk: null,
  uploadRisksResult: null,
  total_risks_count: null,
  org_risks_count: null,
  import_risks_count: null,
};
const riskSlice = createSlice({
  name: "risk",
  initialState: initialState,
  reducers: {
    fetchThreats: () => { },
    fetchVulnerabilities: () => { },
    fetchAssetList: () => { },
    fetchAssetTypeList: () => { },
    fetchReferences: () => { },
    fetchRatings: () => { },
    fetchSources: () => { },
    fetchDashboardData: () => { },
    createRisk: () => { },
    fetchRiskDeptResponders: () => { },
    updateRiskDeptResponder: () => { },
    removeRiskDeptResponder: () => { },
    fetchRiskList: () => { },
    importRisksFromBlueprint: () => { },
    uploadRisks: () => { },
    fetchRisk: () => { },
    updateRisk: () => { },
    addRiskControl: () => { },
    deleteRiskControl: () => { },
    addRiskResponder: () => { },
    removeRiskResponder: () => { },
    createRiskTask: () => { },
    fetchImportRisksCount: () => { },
    exportRiskReport: () => { },
    shareRiskReport: () => { },
    updateRiskDeptResponderWithNewUser: () => { },
    exportOrgRisks: () => { },
    createRiskReport: () => { },
    fetchRiskReport: () => { },
    setThreatsList: (state, action) => {
      state.threatsList = action.payload;
    },
    setVulnerabilitiesList: (state, action) => {
      state.vulnerabilitiesList = action.payload;
    },
    setAssetsList: (state, action) => {
      state.assetsList = action.payload;
    },
    setAssetTypesList: (state, action) => {
      state.assetTypesList = action.payload;
    },
    setReferencesList: (state, action) => {
      state.referencesList = action.payload;
    },
    setSourcesList: (state, action) => {
      state.sourcesList = action.payload;
    },
    setRatingsList: (state, action) => {
      state.ratingsList = action.payload;
    },
    setDashboardData: (state, action) => {
      state.dashboardData = action.payload;
    },
    setDeptResponders: (state, action) => {
      state.deptResponders = action.payload;
    },
    setRiskList: (state, action) => {
      state.risks = action.payload.risks;
      state.total_risks_count = action.payload.total_count;
      state.org_risks_count = action.payload.org_risks_count;
    },
    setCurrentRisk: (state, action) => {
      state.currentRisk = action.payload;
    },
    setUploadRisksResult: (state, action) => {
      state.uploadRisksResult = action.payload;
    },
    clearUploadRisksResult: (state) => {
      state.uploadRisksResult = null;
    },
    clearRiskList: (state) => {
      state.risks = null;
      state.total_risks_count = null;
      state.org_risks_count = null;
    },
    setImportRisksCount: (state, action) => {
      state.import_risks_count = action.payload;
    },
  },
});
export const riskActions = riskSlice.actions;

ReducerRegistry.register("risk", riskSlice.reducer);
